// extracted by mini-css-extract-plugin
export var chip = "_e5-0";
export var filterDropdown = "_e5-5";
export var filterItem = "_e5-6";
export var icon = "_e5-1";
export var removeButton = "_e5-3";
export var removeIcon = "_e5-4";
export var separator = "_e5-2";